import { GlobalSearchSaga } from "./GlobalSearch";

export default [...GlobalSearchSaga];
